import type { ImportedDoc } from "compta-shared";

interface InvoiceAnalysisBadgeProps {
  status: ImportedDoc["analysisStatus"];
  error?: string | null;
}

const InvoiceAnalysisBadge = ({ status, error }: InvoiceAnalysisBadgeProps) => {
  if (status === "analyzing") {
    return <span className="badge text-bg-info">Analyse en cours…</span>;
  }
  if (status === "done") {
    return <span className="badge text-bg-success">Analysée</span>;
  }
  if (status === "failed") {
    return (
      <span className="badge text-bg-danger" title={error || undefined}>
        Échec OCR
      </span>
    );
  }
  return (
    <span className="badge text-bg-secondary">
      {status === "pending" ? "En attente d'analyse" : "À analyser"}
    </span>
  );
};

export default InvoiceAnalysisBadge;
